import { type RouterTabsStore } from "src/lib/tabs/RouterTabsStore.ts";
import type { TabOptions } from "src/lib/tabs-ui/TabsStore.tsx";

let adminTabsStore: RouterTabsStore<TabOptions> | null = null;

export const getAdminTabsStore = () => {
  if (!adminTabsStore) {
    throw new Error("AdminTabsStore has not been initialized yet");
  }
  return adminTabsStore;
};

export const setAdminTabsStore = (
  store: RouterTabsStore<TabOptions> | null,
) => {
  adminTabsStore = store;
};
